import { useTheme } from "@/src/styles/theme-provider";
import { CloseCircle } from "iconsax-react-nativejs";
import { Pressable, Text, View } from "react-native";
import SnapshotAvatar from "../snapshot-avatar";

type UserChipProps = Readonly<{
	user: { displayName?: string; email: string; profileImageUrl?: string | null };
	onRemove: () => void;
}>;

const UserChip = ({ user, onRemove }: UserChipProps) => {
	const { themeVars } = useTheme();
	return (
		<View className="flex-row items-center gap-2 bg-ash rounded-xl px-3 py-2 md:border md:border-ash-3 mr-2">
			<SnapshotAvatar user={user} size={28} />
			<View className="flex-col">
				<Text className="text-xs font-medium text-onyx">{user.displayName}</Text>
				<Text className="text-xs text-ash-2">{user.email}</Text>
			</View>
			<Pressable onPress={onRemove} hitSlop={8} className="hover:bg-ash-3 hover:rounded-full">
				<CloseCircle size={16} color={themeVars["--color-ash-2"] as string} />
			</Pressable>
		</View>
	);
};

export default UserChip;
